import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-not-found',
  imports: [TranslatePipe],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
  standalone: true,
})
export class NotFoundComponent implements OnInit {
  constructor(
    private router: Router,
    private seo: SeoService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.seo.setMeta({
      title: this.translate.instant('notFound.title'),
      description: '',
      robots: 'noindex, follow',
    });
  }

  onRedirect() {
    this.router.navigate(['/discover']).then(() => {});
  }
}
